import React from 'react';
import { Trans } from 'react-i18next';
import Spinner from '@/components/loading/Spinner';
import AIStopButton from '@/components/editor/ai/AIStopButton';

type Props = {
    onStop?: () => void;
};

const AIGeneratingIndicator = React.memo(({ onStop }: Props) => {
    return (
        <div className="flex items-center justify-between py-0.5">
            <div className="flex items-center">
                <div className="mr-2">
                    <Spinner size={14} />
                </div>
                <div className="text-sm text-saga-text dark:text-saga-gray-500">
                    <Trans i18nKey="ai.generating_dotted" />
                </div>
            </div>
            {onStop && <AIStopButton onClick={onStop} />}
        </div>
    );
});

AIGeneratingIndicator.displayName = 'AIGeneratingIndicator';

export default AIGeneratingIndicator;
